import { range, readOnly } from 'models/restutil';
import { PenOrderDto } from './PenOrder';
import { PenDto } from './Pen';

export class PenOrderItem {
  public static ApiUrl = 'api/pen-order-item';

  @range(null, 20)
  NetIdentifier: string;
  PenOrderId: number;
  PenOrder: PenOrderDto;
  PenId?: number;
  Pen: PenDto;
  Id: number;
  Created?: Date;
  Updated?: Date;
  @readOnly()
  IsDeleted: boolean;
}
